import { render, staticRenderFns } from "./StudentManagement.vue?vue&type=template&id=69d00e03&scoped=true&"
import script from "./StudentManagement.vue?vue&type=script&lang=js&"
export * from "./StudentManagement.vue?vue&type=script&lang=js&"
import style0 from "./StudentManagement.vue?vue&type=style&index=0&id=69d00e03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d00e03",
  null
  
)

export default component.exports